export const IMG_WITH_TEXT_SIZES = '(max-width: 768px) 327px, 648px';
